import $ = require("jquery");
import MapView = require("../../views/MapView");
import Utils = require("../../utils");
import Portal = require("portal-gis");
import Mediator = require("../../mediator");
import Templates = require("../../models/defaults");

class GroupHelper {

    static about = `

Facilitates merging layers into the maplet configuration using _api.merge_.

Used by the following factories to extend the maplet configuration:

* [ags-discovery](#app/layer-factory/ags-discovery)
* [group](#app/layer-factory/group)
* [wms](#app/layer-factory/wms)

`;

    static options = {
        "layerType": {
            "about": "Merge child layers with the main configuration",
            "domain": "merge",
            "default": "merge"
        }
    }

    constructor(public layer: Portal.MapLayerLeaf, public view: MapView, public mediator: Mediator, public options: Rhythm.GIS.Dictionary<string>) {
        Utils.defaults(options, {
            layerType: GroupHelper.options.layerType.default
        });
    }


    // layer now has child layers, merge should result in layer picker getting refreshed
    // but it would also be reasonable to expect it to come back into these layer factories
    // which we do not want since we're creating them now.  How to prevent?
    merge(childLayers?: Portal.MapLayerLeaf[]) {
        if (childLayers) {
            this.layer.Layers = {
                Layers: childLayers
            };
        }

        let layer = this.layer;
        while (true) {
            let parent = Utils.extend(layer).parent;
            // stop once we bubble up to the map definition..we need to merge the root layer
            // because root layers are the only layers added to the collection (nested collections got messy)
            if (!parent || (parent["Viewport"])) break;
            layer = parent;
        };

        // notify api of a change to this layer, set _timestamp to force a model "change"
        layer["_timestamp"] = Date.now();
        this.mediator.api.merge({
            Map: {
                Layers: {
                    Layers: [layer]
                }
            }
        });

    }

    create() {
        let layerType = this.options["layerType"];
        let factory = this[layerType];
        if (!factory) throw `Invalid layerType option: ${layerType}`;
        return factory && factory.call(this);
    }

}

export = GroupHelper;